import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-confirm-create',
  templateUrl: './modal-confirm-create.component.html',
  styleUrls: ['./modal-confirm-create.component.scss']
})
export class ModalConfirmCreateComponent {
 prospecto = "Maria Grisa";
}
